// extracted by mini-css-extract-plugin
module.exports = {"toolSectionTitle":"ToolSectionTitle_toolSectionTitle__3QKBj"};